import mutations from './moduleMonthlyDonationsMutations.js'
import actions from './moduleMonthlyDonationsActions.js'
import getters from './moduleMonthlyDonationsGetters.js'

const getDefaultState = () => {
  return {
    donationsState: null,//null, loading, ready
    donations: [],
  }
}

export default {
  isRegistered: false,
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    ...mutations,
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions,
  getters
}

